import { FETCH_LOCATIONS } from '#action/types';

const defaultState = [];

export default function (state = defaultState, action) {
  switch (action.type) {
    case FETCH_LOCATIONS:
      return action.payload;
    default:
      return state;
  }
}
